import { ConfirmationDialogInput } from "./ConfirmationDialogEntities";

/**
 * NOTE: This is a standalone helper for PhoneToCnp confirmation dialogs.
 * For usage, pass the input directly to the ConfirmationDialog component.
 * These helpers create pre-configured inputs for common scenarios.
 */

/**
 * Creates the input configuration for the fixed fare cancel trip dialog.
 * Shows additional message about payment hold release.
 */
export function GetFixedFareCancelDialogInput(): ConfirmationDialogInput {
    return {
        title: "Cancel trip?",
        message: "This will cancel your booking.",
        additionalMessage: "Your payment hold will be released immediately, but your bank may take longer to return the funds.",
        cancelButtonText: "Keep trip",
        confirmButtonText: "Cancel trip",
        confirmButtonColor: "#E7000B"
    };
}

/**
 * Creates the input configuration for the metered booking cancel trip dialog.
 * Shows simpler message without payment hold information.
 */
export function GetMeteredCancelDialogInput(): ConfirmationDialogInput {
    return {
        title: "Cancel trip?",
        message: "This will cancel your booking.",
        cancelButtonText: "Keep trip",
        confirmButtonText: "Cancel trip",
        confirmButtonColor: "#E7000B"
    };
}

/**
 * Creates the input configuration for the remove saved card dialog.
 */
export function GetRemoveCardDialogInput(): ConfirmationDialogInput {
    return {
        title: "Remove this card?",
        message: "This card will be removed from your saved payment methods.",
        cancelButtonText: "Cancel",
        confirmButtonText: "Remove card",
        confirmButtonColor: "#E7000B"
    };
}
